import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import Button from '@component/form/element/button';

const GridBar = ({ title, description, onDownloadAll }) => {
  return (
    <div className="grid__bar">
      <div className="grid__meta">
        <div className="grid__title">{title}</div>
        <div className="grid__subtitle">{description}</div>
      </div>
      <Button
        onClick={onDownloadAll}
        text={I18n.t('transfer.buttons.download_all')}
        className="u-margin-left"
      />
    </div>
  );
};

GridBar.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDownloadAll: PropTypes.func.isRequired,
};

export default React.memo(GridBar);
